module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("T")]), _vm._v("EXT")], 1), _vm._v(". "), _c('b', [_vm._v("Mikhaíl Yúrievich Lérmontov")]), _vm._v(", 1830. Title: "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Нищий")]), _vm._v(" (A Beggar); first published in 1844. Lermontov revised line 3 to read “A withered wretch, barely alive,” but this reading was not published until 1910.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Set by many Russian composers, including Donaurov (1871), Shashina (1879), Nápravník (Op. 31/3, 1879), Cui (Op. 27/3, 1884), Medtner (Op. 3/1, 1904), and Alfred Schnittke (Two Songs for Voice and Piano, Early Works, 1954–5).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("ETER")], 1), _vm._v(". Binary. Iambic tetrameter:")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("USIC")], 1), _vm._v(". Dated 29 April 1890 on the manuscript. Without opus number. G Minor. 4/4, Andante. For Low Voice: A–e"), _c('sup', [_vm._v("1")]), _vm._v(" flat. Dedicated to "), _c('b', [_vm._v("Mikhaíl Akímovich Slónov")]), _vm._v(" (1868-1930), a singer (baritone), a fellow student at the Moscow Conservatory and one of Rachmaninoff’s closest friends. First published posthumously in 1947 in "), _c('i', [_vm._v("Lamm")]), _vm._v(" (see "), _c('i', [_vm._v("Lamm")]), _vm._v(" in the "), _c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("B")]), _vm._v("IBLIOGRAPHY")], 1), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("R")]), _vm._v("ECORDINGS")], 1), _vm._v(". Amaize, Burchuladze, Kharitonov, Koptchak, Leiferkus, Pirogov, Reizen, Söderström, Stepanovich, Suchkova, Verbitskaya, Vladimirov.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Donaurov: Andrei Labinsky, Klavdiia Tugarinova.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Medtner: Vassily Savenko.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "chtop",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "87%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('td'), _c('td', [_c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("У врат обители святой")])]), _vm._v(" "), _c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("At the gates of the holy abode")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Like several other Russian composers, Rachmaninoff was drawn to this lyric of Mikhail Lermontov (1814–1841) by the powerful and original way it expresses rejection, “best feelings” spurned, in the image of the beggar by the monastery gates who asks for a piece of bread and is handed a stone. It is a scene easily imagined by a Russian reader; in fact, as we know from the memoirs of Yekaterina Sushkova, a scene like this actually took place outside St. Sergius Lavra near Moscow. In August 1830 a party of young people, including the 18-year-old Sushkova and the sixteen-year-old Lermontov, made an excursion to the monastery, with Sushkova’s grandmother riding in the lead as chaperone. At the gates they gave some coins to a beggar, who thanked them and told them the story of some other young people who had dropped stones into his cup. Later, at the inn, Lermontov, instead of joining them all at dinner, found a pencil and a scrap of paper, and, kneeling at a chair, wrote out this poem, handing it to Sushkova as he sat down to his bowl of chilled fish soup with kvass ("), _c('i', [_vm._v("Sushkova")]), _vm._v(", 114-7). This intense Romantic gesture just before the soup course is almost a parody of what Lermontov would do so well later in mature work like his novella “Princess Mary,” but this early poem already shows his authentic voice.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rachmaninoff saw the emotional power in this lyric, and his response to it is impressive. His music pays attention to the words. His own authentic voice is heard unmistakably in the piano part, which establishes the emotional terms at the outset, and supports the voice part eloquently throughout. A third of the song’s 45 bars are for piano alone. The beginning of the voice part, with its six repeated B-flats, contrasts with the emotionally strong introduction, and it can be ponderous if taken too slowly and allowed to drag. The baritone Sergei Leiferkus, who sings it in the original key, manages the right tempo, moving ahead as he rises to the high point of the song, marked "), _c('i', [_vm._v("con moto")]), _vm._v(" (with animated movement), “thus did I beg for your love, with bitter tears, with longing.” At this point the piano again has a moment all to itself, to pause for lyrical reflection and let the words sink in. The song can work with other voices, too, as the fine recording by the Swedish soprano Elisabeth Söderström shows. She brings an underlying sense of animation to the whole song, while her accompanist, Vladimir Ashkenazy, plays the notes in the piano part with a chaste lyricism, not adding false emotional emphasis or arpeggios that are not in the score.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("У врат обители святой")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Стоял просящий подаянья")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Бессильный, бледный и худой")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("От глада, жажды и страданья.")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Куска лишь хлеба он просил")]), _vm._v(",")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И взор являл живую муку.")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И кто-то камень положил")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("В его протянутую руку.")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Так я молил твоей любви")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("С слезами горькими, с тоскою;")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Так чувства лучшие мои")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Навек обмануты тобою.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("U vrát abíteli svjatój")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("At the gate of the holy cloister")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Stajál prasjáshchij padaján’ja,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("A man stood begging for alms,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Bessíl’nyj, blédnyj i khudój")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Weak, pale, and thin")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Ad gláda, zházhdy i stradán’ja.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("From hunger, thirst, and suffering.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("Kuská lish khléba on prasíl,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("A piece of bread was all he asked,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I vzór javljál zhyvúju múku.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("His look revealed keen torment.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I któ-ta kámen’ palazhýl")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And someone put a stone")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("V jevó pratjánutuju rúku.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Into his outstretched hand.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("Tak já malíl tvajéj ljubví,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("Thus did I beg for your love,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("S slezámi gór’kimi, s taskóju;")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("With bitter tears, with longing;")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Tak chústva lúchshyje mají")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Thus were my best feelings")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Navék abmánuty tabóju.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Forever betrayed by you.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("A piece of bread was all he asked…")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1e7b294","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013_Chapter_01.vue
// module id = 93
// module chunks = 0